import {
  getGroupBuyingReportList,
  getMemberReportList,
  getMemberReport,
  getTempReport,
} from '@/api/reports';
import {
  GET_GROUP_BUYING_REPORT_LIST_DONE,
  GET_GROUP_BUYING_REPORT_LIST,
  GET_MEMBER_REPORT_LIST_DONE,
  GET_MEMBER_REPORT_LIST,
  GET_MEMBER_REPORT,
  GET_TEMP_REPORT,
  GETTING_GROUP_BUYING_REPORT_LIST,
  GETTING_MEMBER_REPORT_LIST,
} from './constants';

export default {
  async [GET_GROUP_BUYING_REPORT_LIST]({ commit }, params = {}) {
    commit(GETTING_GROUP_BUYING_REPORT_LIST, true);
    try {
      const res = await getGroupBuyingReportList(params);
      commit(GET_GROUP_BUYING_REPORT_LIST_DONE, res);
      return Promise.resolve();
    } catch (error) {
      commit(GET_GROUP_BUYING_REPORT_LIST_DONE, {});
      return error;
    } finally {
      commit(GETTING_GROUP_BUYING_REPORT_LIST, false);
    }
  },
  async [GET_MEMBER_REPORT_LIST]({ commit }, params = {}) {
    commit(GETTING_MEMBER_REPORT_LIST, true);
    try {
      const res = await getMemberReportList(params);
      commit(GET_MEMBER_REPORT_LIST_DONE, res);
      return Promise.resolve();
    } catch (error) {
      commit(GET_MEMBER_REPORT_LIST_DONE, {});
      return error;
    } finally {
      commit(GETTING_MEMBER_REPORT_LIST, false);
    }
  },
  [GET_MEMBER_REPORT](ctx, { id, params = {} }) {
    return getMemberReport(id, params);
  },
  [GET_TEMP_REPORT](ctx, key) {
    return getTempReport(key);
  },
};
